export function displayParameterUnit(unit?: string | null): string {
  if (!unit) return "";
  if (unit.replace(/\s/g, "").toLowerCase() === "inchmm") return "inch | mm";
  return unit;
}
